// extracted by mini-css-extract-plugin
export default {"mainDiv":"Home_mainDiv__mWvtX"};